import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import BrandGuidesList from '../BrandGuidesList';
import BrandGuideCreator from '../BrandGuideCreator';
import { ModuleHeader } from '../ui/ModuleHeader';
import { GlassCard } from '../ui/GlassCard';
import './BrandManagement.css';

interface ContentContextType {
    selectedProjectId: string | undefined;
    onProjectSelect: (id: string | undefined) => void;
}

const BrandManagement: React.FC = () => {
    const { selectedProjectId } = useOutletContext<ContentContextType>();
    const [mode, setMode] = useState<'list' | 'create'>('list');

    // Force list mode if project changes
    React.useEffect(() => {
        setMode('list');
    }, [selectedProjectId]);

    if (!selectedProjectId) {
        return (
            <div className="brand-management-empty">
                <GlassCard variant="strong" padding="lg" className="empty-state-card">
                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                        <h2 style={{ margin: '0 0 16px 0', fontSize: '26px', fontWeight: 300 }}>Brand Portal</h2>
                        <p style={{ margin: 0, color: 'var(--text-secondary)' }}>
                            Please select a project from the sidebar to manage its brand guides.
                        </p>
                    </div>
                </GlassCard>
            </div>
        );
    }

    return (
        <div className="brand-management-container" style={{ padding: '24px' }}>
            <ModuleHeader
                title="Brand Portal"
                breadcrumb={['Home', 'Brand Portal']}
            />

            <div style={{ marginTop: '24px' }}>
                {mode === 'list' && (
                    <BrandGuidesList
                        projectId={selectedProjectId}
                        onCreate={() => setMode('create')}
                        onEdit={(guide) => {
                            window.open(`/brand-portal/${guide.brand_guide_id}`, '_blank');
                        }}
                    />
                )}

                {mode === 'create' && (
                    <BrandGuideCreator
                        projectId={selectedProjectId}
                        onClose={() => setMode('list')}
                        onSuccess={() => {
                            setMode('list');
                            // List will reload on mount/prop change
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default BrandManagement;